import {
  branch_category_overall_v3,
  branch_category_cluster_v3,
  branch_category_area_v3,
  branch_category_branch_v3,
} from "../../v3-services/reports/branch_category_service";
import { actionTypes } from "../action_types";

const getBranchCategory = (fetchFunction, type) => (data) => (dispatch) => {
  return fetchFunction(data).then((resp) => {
    if (resp.problem === null) {
      dispatch({
        type,
        payload: resp.data !== null ? resp.data : { branchCategories: [] },
      });
    }
    return Promise.resolve(resp);
  });
};

export const GetBranchCategoryOverall_v3 = getBranchCategory(
  branch_category_overall_v3,
  actionTypes.REPORTS_BRANCHCATEGORY_GET_OVERALL
);

export const GetBranchCategoryCluster_v3 = getBranchCategory(
  branch_category_cluster_v3,
  actionTypes.REPORTS_BRANCHCATEGORY_GET_CLUSTER
);

export const GetBranchCategoryArea_v3 = getBranchCategory(
  branch_category_area_v3,
  actionTypes.REPORTS_BRANCHCATEGORY_GET_AREA
);

export const GetBranchCategoryBranch_v3 = getBranchCategory(
  branch_category_branch_v3,
  actionTypes.REPORTS_BRANCHCATEGORY_GET_BRANCH
);
